import { ScrollDirection, ScrollParams } from '@modules/dashboard/types';

let currentSpeed: number | null = null;
let isScrolling = false;

const startWindowScrollLoop = () => {
  if (isScrolling || !currentSpeed) {
    return;
  }

  let prevTimestamp = 0;
  const scroll = (timestamp: number) => {
    if (currentSpeed === null) {
      return;
    }

    const timeSinceLastScroll = prevTimestamp ? timestamp - prevTimestamp : 0;
    const adjustedSpeed = (currentSpeed / 1000) * timeSinceLastScroll;

    window.scrollBy(0, adjustedSpeed);

    if (isScrolling) {
      prevTimestamp = timestamp;
      window.requestAnimationFrame(scroll);
    }
  };

  window.requestAnimationFrame(scroll);
  isScrolling = true;
};

export function startOrContinueAutoscroll({ speed, direction }: ScrollParams) {
  const directionMultiplier = direction === ScrollDirection.Up ? -1 : 1;
  currentSpeed = speed * directionMultiplier;
  if (!isScrolling) {
    startWindowScrollLoop();
  }
}

export function stopAutoscroll() {
  isScrolling = false;
}
